module.exports = __webpack_public_path__ + "media/images/front/icon_spmenu_point-7fb8c77ff0a3fe439afdff0070134ee0.png";